module.exports = __webpack_public_path__ + "img/img_asset_valve.b31a02be.svg";